// Replaced during DevOps deployment with environment specific values
let APP_CLIENT_ID = '#{AppClientId}';
let ROOT_URL = '#{BackendUrl}';
let SP_HOST_URL = '#{SharePointHostUrl}';
let EXAM_MODE_SETTING = '#{ExamMode}';

// Application Client ID if running webapp locally
if (APP_CLIENT_ID.startsWith('#')) {
    //APP_CLIENT_ID = 'ff467b9c-3f5f-4b28-944c-6b06215eaca9'

    //APP_CLIENT_ID='1c61bbe0-ab07-4fd4-9da9-337f1cb05a7b'
    //APP_CLIENT_ID = '65b8d8d2-9673-4161-a4e6-2b0ea50f6d00'

    //APP_CLIENT_ID = '8c754382-0b45-43fd-9e77-eb140af33090'

    APP_CLIENT_ID = '1c61bbe0-ab07-4fd4-9da9-337f1cb05a7b';
}

// Backend URL for if running webapp locally
if (ROOT_URL.startsWith('#')) {
    ROOT_URL = 'https://zokratesstage.azurewebsites.net/API';
    // ROOT_URL = 'https://zdebug.azurewebsites.net/API';
    // ROOT_URL = "https://localhost:7220/API";
    // ROOT_URL = "http://localhost:32771/API";

    //ROOT_URL = "https://wa-zokratesapi-prod.azurewebsites.net/API"
    //ROOT_URL = "https://d2lcmrpx-7220.euw.devtunnels.ms/API"
}

// SharePoint Host URL if running webapp locally
if (SP_HOST_URL.startsWith('#')) {
    SP_HOST_URL = '?SPHostUrl=https://enablestage.sharepoint.com';
}

// The deployment value is authoritative. The query-string override makes it
// possible to validate exam mode without producing a separate build.
const examModeQueryMatch = typeof window !== 'undefined'
    ? window.location.search.match(/(?:\?|&)examMode=([^&]+)/i)
    : null;
    console.log("ExamModeQueryMatch:", examModeQueryMatch)
const examModeQueryValue = examModeQueryMatch
    ? decodeURIComponent(examModeQueryMatch[1]).toLowerCase()
    : '';
const examModeDeploymentValue = EXAM_MODE_SETTING.startsWith('#')
    ? ''
    : EXAM_MODE_SETTING.toLowerCase();
const EXAM_MODE = examModeQueryValue === 'true' || examModeQueryValue === '1'
    || examModeDeploymentValue === 'true' || examModeDeploymentValue === '1';

export { APP_CLIENT_ID, ROOT_URL, SP_HOST_URL, EXAM_MODE };
